import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dialogex',
  templateUrl: './dialogex.component.html',
  styleUrls: ['./dialogex.component.css']
})
export class DialogexComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
